import BaseModule from '@core/modules/base-module/base-module';
import CollapsibleNewsFilters from '@pj/components/filters/collapsible-news-filters/collapsible-news-filters';

let filters = null;
//
const newsFilters = new BaseModule();
newsFilters.name = "news-filters";
newsFilters.init(that => {
  filters= new CollapsibleNewsFilters(that.elements,'news-list-filters');
  filters.init();
});

newsFilters.onResize(function () {
  if(filters){
    filters.onResize();
  }
});
